export default __webpack_public_path__ + "static/media/Alena_Omovych.2a4b9a3a.png";